import type { PagedResult, PaginationParams, WorkItemAttachment } from '@/types'
import { client } from './client'

export const intentAttachmentsApi = {
    getByIntent: (projectId: string, intentId: string, params?: PaginationParams) =>
        client.get<PagedResult<WorkItemAttachment>>(
            `/projects/${projectId}/intents/${intentId}/attachments`,
            { params }
        ).then(r => r.data),

    upload: (projectId: string, intentId: string, files: File[]) => {
        const formData = new FormData()
        files.forEach(file => formData.append('files', file))
        return client.post<{ attachmentIds: string[] }>(
            `/projects/${projectId}/intents/${intentId}/attachments/upload`,
            formData,
            { headers: { 'Content-Type': undefined } }
        ).then(r => r.data)
    },

    delete: (projectId: string, intentId: string, attachmentId: string) =>
        client.delete(`/projects/${projectId}/intents/${intentId}/attachments/${attachmentId}`),

    getDownloadUrl: (projectId: string, intentId: string, attachmentId: string) =>
        client.get<string>(
            `/projects/${projectId}/intents/${intentId}/attachments/${attachmentId}/download-url`
        ).then(r => r.data),
}
